import {
  Box,
  Button,
  Flex,
  HStack,
  Stack,
  Switch,
  FormControl,
  FormLabel,
  useToast,
  Heading,
  Divider,
  VStack,
  Collapse,
  IconButton,
  useDisclosure,
  Text,
  RadioGroup,
  Radio,
  Checkbox,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Tooltip,
} from "@chakra-ui/react";
import { ChevronDownIcon, ChevronUpIcon, RepeatIcon } from "@chakra-ui/icons";
import CustomInput from "components/common/customInput/CustomInput";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  creditIndicator,
  departmentsOptions,
  regionsOptions,
  tillomedList,
} from "../utils/constant";
import { companyCodes } from "utils/financeForm/companyCodes";
import { appRequest } from "routes";
import { AppContext } from "AppProvider/AppContext";
import { extractVendorAddress } from "../utils/function";
import { addNA, addNAObject, getFiUser, sumLineAmounts } from "../../function";
import TdsGlSection from "App/BsesPoc/components/Approvals/component/TdsGlSection/TdGlAccountSection";
import { taxJuridictionOptions } from "../../constant";
import AssignDocumentModal from "../../../Approvals/component/AssignDocumentModal";
import { MdAssignmentInd } from "react-icons/md";
export default function MultipleLineItemsForm({
  data,
  formData,
  setFormData,
  companyCode,
  setCompanyCode,
  lineItems,
  setLineItems,
  dynamicSchemaData,
  isLevel,
  isDisabled,
  documentFlow,
  documentId,
  approval
}: any) {
  const { workflowProcess, accountDetails, workFlowData } =
    useContext(AppContext);
  const toast = useToast();
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const prevCompanyCode = useRef<string | null>(null);
  const [fetchDomesticApprovers, setFetchDomesticApprovers] = useState<any>([]);
  const [fetchZuventusApprovers, setFetchZuventusApprovers] = useState<any>([]);
  const [MarcanApproval2, setFetchMarcanApproval2] = useState<any>([]);
  const [companyCodeOptions, setCompanyCodeOptions] = useState<any[]>([]);
  const [gstVendorCodeOptions, setGstVendorCodeOptions] = useState<any[]>([]);
  const [selectedVendor, setSelectedVendor] = useState<any>(null);
  const [vendorSearch, setVendorSearch] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [plantCodeOptions, setPlantCodeOptions] = useState<any[]>([]);

  const [businessPlaceOptions, setBusinessPlaceOptions] = useState<any[]>([]);
  const [businessPlaceCache, setBusinessPlaceCache] = useState<
    Record<string, any[]>
  >({});
  const [profitCenterOptions, setProfitCenterOptions] = useState<any[]>([]);
  const [glAccountsOptions, setGlAccountsOptions] = useState<any[]>([]);
  const [tdsTaxCodeOptions, setTdsTaxCodeOptions] = useState<any[]>([]);
  const [costCenterCache, setCostCenterCache] = useState<Record<string, any[]>>(
    {},
  );
  const [taxCodeOptions, setTaxCodeOptions] = useState([]);

  const [businessAreaCache, setBusinessAreaCache] = useState<
    Record<string, any[]>
  >({});
  const [internalOrderCache, setInternalOrderCache] = useState<
    Record<string, any[]>
  >({});

  // Disclosure hooks for collapsible sections
  const { isOpen: isGeneralOpen, onToggle: toggleGeneral } = useDisclosure({
    defaultIsOpen: true,
  });
  const { isOpen: isVendorOpen, onToggle: toggleVendor } = useDisclosure({
    defaultIsOpen: true,
  });
  const { isOpen: isInvoiceOpen, onToggle: toggleInvoice } = useDisclosure({
    defaultIsOpen: true,
  });
  const { isOpen: isTaxOpen, onToggle: toggleTax } = useDisclosure({
    defaultIsOpen: true,
  });
  const { isOpen: isApprovalOpen, onToggle: toggleApproval } = useDisclosure({
    defaultIsOpen: true,
  });
  const { isOpen: isLineItemsOpen, onToggle: toggleLineItems } = useDisclosure({
    defaultIsOpen: true,
  });

  const [assignDocument, setAssignDocument] = useState<any>({
    open: false,
    data: null,
  });

  console.log('the form data are', formData)
  console.log('the form data are', dynamicSchemaData?.fields?.Vendor_Name?.editFieldValue || dynamicSchemaData?.fields?.Vendor_Name?.originalValue)

  useEffect(() => {
    if (formData?.gstVendorCode) {
      setGstVendorCodeOptions([formData.gstVendorCode]);
      setSelectedVendor(formData.gstVendorCode);
      // setFormData((prev: any) => ({
      //   ...prev,
      //   gstVendorCode: formData.gstVendorCode,
      // }));
    }
  }, [formData, setGstVendorCodeOptions, setSelectedVendor]);

  const fetchDomesticApproversFunction = async () => {
    const lists: { label: string; value: string }[] = [];
    try {
      const approvers: any = await appRequest(
        "user",
        "fetchDomesticApprovers",
        { ...workflowProcess },
      );
      if (Array.isArray(approvers?.data)) {
        approvers.data?.forEach((wf: any) => {
          if (Array.isArray(wf?.approvers)) {
            wf.approvers.forEach((user: any) => {
              if (user?.label && user?.value) {
                lists.push({ label: user.label, value: user.value });
              }
            });
          }
        });
      }
      setFetchDomesticApprovers(lists);
    } catch (err: any) {
      console.error("Error fetching domestic approvers:", err);
    }
  };

  const fetchZuventusApproversFunction = async () => {
    const lists: { label: string; value: string }[] = [];
    try {
      const approvers: any = await appRequest(
        "user",
        "fetchZuventusApprovers",
        { ...workflowProcess },
      );
      if (Array.isArray(approvers?.data)) {
        approvers.data?.forEach((wf: any) => {
          if (Array.isArray(wf?.approvers)) {
            wf.approvers.forEach((user: any) => {
              if (user?.label && user?.value) {
                lists.push({ label: user.label, value: user.value });
              }
            });
          }
        });
      }
      setFetchZuventusApprovers(lists);
    } catch (err: any) {
      console.error("Error fetching domestic approvers:", err);
    }
  };

  const fetchMarcanApproversFunction = async () => {
    try {
      const response: any = await appRequest("user", "fetchMarcanApproval2", {
        ...workflowProcess,
      });
      const lists: { label: string; value: string }[] = Array.isArray(
        response?.data,
      )
        ? response.data
        : [];
      setFetchMarcanApproval2(lists);
    } catch (err: any) {
      console.error("Error fetching Marcan approvers:", err);
    }
  };

  useEffect(() => {
    if (workflowProcess?.processName === "domestic") {
      fetchDomesticApproversFunction();
    }
    if (workflowProcess?.processName === "zuventus") {
      fetchZuventusApproversFunction();
    }
    if (workflowProcess?.processName === "marcan") {
      fetchMarcanApproversFunction();
    }
  }, []);

  // --- Synchronize lineItems with formData, cleaning frontend-specific fields ---
  useEffect(() => {
    if (lineItems.length === 0) return;
    const cleanLineItems = lineItems.map((item: any) => {
      const {
        costCenterOptions,
        businessAreaOptions,
        internalOrderOptions,
        ...cleanItem
      } = item;
      return {
        ...cleanItem,
        Item_Description: item.description || item?.Item_Description,
      };
    });
    setFormData((prev: any) => ({
      ...prev,
      lineItems: cleanLineItems,
    }));
  }, [lineItems, setFormData]);

  // Ref to track previous buyer info to prevent redundant API calls
  const prevBuyerInfo = useRef({ name: null, gstin: null });

  // --- Fetch company codes ---
  useEffect(() => {
    if (isLevel && data?.[0]?.companyCode) return;
    const fetchCompanyCodes = async () => {
      try {
        const buyerName =
          dynamicSchemaData?.fields?.Buyer_Name?.editFieldValue ||
          dynamicSchemaData?.fields?.Buyer_Name?.originalValue;
        const buyerGstIn =
          dynamicSchemaData?.fields?.Buyer_GSTIN_OR_Tax_Identification_Number
            ?.editFieldValue ||
          dynamicSchemaData?.fields?.Buyer_GSTIN_OR_Tax_Identification_Number
            ?.originalValue;

        // Skip fetch if buyer info hasn't changed AND we already have options
        if (
          companyCodeOptions.length > 0 &&
          prevBuyerInfo.current.name === buyerName &&
          prevBuyerInfo.current.gstin === buyerGstIn
        ) {
          return;
        }

        const payload = {
          buyerName,
          buyerGstin: buyerGstIn,
          type: "getCompanyCode",
          ...workflowProcess,
        };
        const response: any = await appRequest(
          "user",
          "masterFinancialApi",
          payload,
        );
        if (response?.status === "success") {
          const options =
            response?.data?.map((item: any) => ({
              label: item,
              value: item,
            })) || [];
          setCompanyCodeOptions(options);

          // Update ref with new values
          prevBuyerInfo.current = { name: buyerName, gstin: buyerGstIn };

          if (options?.length > 0) {
            // Only update companyCode if it's not already set to avoid cascading re-fetches
            if (!companyCode?.value) {
              setCompanyCode(options[0]);
              setFormData((prev: any) => ({ ...prev, companyCode: options[0] }));
            }
          }
        }
      } catch (error: any) {
        toast({
          title: "Failed to load company codes",
          description: error?.message || "Please try again later.",
          status: "error",
          duration: 4000,
        });
        setCompanyCodeOptions(companyCodes);
      }
    };
    fetchCompanyCodes();
  }, [toast, isLevel, dynamicSchemaData, data, companyCodeOptions.length, companyCode?.value]);

  // --- Fetch GST Vendor Code ---




  // useEffect(() => {
  //   setFormData((prev: any) => {
  //     const currentVal = sumLineAmounts(lineItems)
  //     return { ...prev, tdsBasicAmount: currentVal };
  //   });
  // }, [lineItems, setFormData]);

  useEffect(() => {
    if (!companyCode || formData?.gstVendorCode) return;
    const gstin =
      dynamicSchemaData?.fields?.Vendor_GSTIN_OR_Tax_Identification_Number
        ?.editFieldValue ||
      dynamicSchemaData?.fields?.Vendor_GSTIN_OR_Tax_Identification_Number
        ?.originalValue;
    const fetchGstVendorCode = async () => {
      try {
        const payload = {
          companyCode: companyCode?.value,
          type: "getGstVendorCode",
          gstin,
          ...workflowProcess,
        };
        const response: any = await appRequest(
          "user",
          "masterFinancialApi",
          payload,
        );
        if (response?.status === "success" && Array.isArray(response?.data)) {
          const options = response.data.map((it: any) => ({
            label: `${it?.label || it?.vendorName || it?.vendorCode} -> ${it?.vendorAddress
              }`,
            value: it?.vendorCode,
          }));
          setGstVendorCodeOptions(options);
          setSelectedVendor(options[0] || null);
          setFormData((prev: any) => ({
            ...prev,
            gstVendorCode: prev.gstVendorCode || options[0] || null,
          }));
        } else {
          setGstVendorCodeOptions([]);
          setSelectedVendor(null);
        }
      } catch (error: any) {
        toast({
          title: "Failed to load GST Vendor Code",
          description: error?.message || "Please try again later.",
          status: "error",
          duration: 4000,
        });
        setGstVendorCodeOptions([]);
        setSelectedVendor(null);
      }
    };
    fetchGstVendorCode();
  }, [companyCode, dynamicSchemaData, toast, setFormData, isLevel, data]);

  // --- Fetch TDS Tax Codes ---
  useEffect(() => {
    if (!companyCode || !selectedVendor) return;
    const fetchTdsTaxCodes = async () => {
      try {
        const payload = {
          type: "getTdsTaxCode",
          companyCode: companyCode?.value,
          vendorCode: selectedVendor?.value,
          ...workflowProcess,
        };
        const response: any = await appRequest(
          "user",
          "masterFinancialApi",
          payload,
        );
        if (response?.status === "success" && Array.isArray(response?.data)) {
          // const options = response.data.map((code: string) => ({
          //   label: code,
          //   value: code,
          // }));
          const options = response.data.map((code: any) => ({
            label: code?.label,
            value: code?.tdsTaxCode
          }));
          setTdsTaxCodeOptions(options);
        } else {
          setTdsTaxCodeOptions([]);
          setFormData((prev: any) => ({
            ...prev,
            tdsTaxCode: null,
          }));
        }
      } catch (error: any) {
        toast({
          title: "Failed to load TDS Tax Codes",
          description: error?.message || "Please try again later.",
          status: "error",
          duration: 4000,
        });
      }
    };
    fetchTdsTaxCodes();
  }, [companyCode, selectedVendor, toast, setFormData, isLevel, data]);

  // --- Vendor Search ---
  const handleVendorSearch = async () => {
    if (isLevel) return;
    if (!vendorSearch?.trim() || !companyCode) {
      toast({
        title: "Enter vendor name and select company",
        status: "warning",
        duration: 3000,
      });
      return;
    }
    setIsSearching(true);
    try {
      const payload = {
        companyCode: companyCode?.value,
        type: "getVendorByName",
        vendorName: vendorSearch.trim(),
        ...workflowProcess,
      };
      const response: any = await appRequest(
        "user",
        "masterFinancialApi",
        payload,
      );
      if (response?.status === "success" && Array.isArray(response?.data)) {
        const options = response.data.map((it: any) => ({
          label: `${it?.label || it?.vendorName || it?.vendorCode} -> ${it?.vendorAddress
            }`,
          value: it?.vendorCode,
        }));
        setGstVendorCodeOptions(options);
      }
    } catch (error: any) {
      toast({
        title: "Failed to search vendor",
        description: error?.message || "Please try again later.",
        status: "error",
      });
    } finally {
      setIsSearching(false);
    }
  };

  // --- Options for invoice type ---
  const invoiceTypeOptions = [
    { label: "KG - Vendor Credit Memo", value: "KG" },
    { label: "KR - Vendor Invoice", value: "KR" },
  ];

  // --- Simple update for non-cascading fields ---
  const updateLineItem = useCallback(
    (index: number, key: string, value: any) => {
      const updatedLineItems = lineItems.map((itm: any, i: number) =>
        i === index ? { ...itm, [key]: value } : itm,
      );
      setLineItems(updatedLineItems);
    },
    [lineItems, setLineItems],
  );

  const fetchProfitCenterOptions = useCallback(
    async (isManual = false) => {
      if (!companyCode?.value) return;

      try {
        const payload = {
          type: "getProfitCenter",
          companyCode: companyCode?.value,
          ...workflowProcess,
        };
        const response: any = await appRequest(
          "user",
          "masterFinancialApi",
          payload,
        );
        if (response?.status === "success" && Array.isArray(response?.data)) {
          const options = response.data.map((pc: any) => ({
            label: pc.label || pc.profitCenter,
            value: pc.profitCenter,
            description:
              pc.profitCenterDescription || pc.label || pc.profitCenter,
          }));
          setProfitCenterOptions(options);
          if (isManual) {
            toast({
              title: "Profit Centers Refreshed",
              status: "success",
              duration: 2000,
              isClosable: true,
            });
          }
        }
      } catch (error: any) {
        toast({
          title: "Failed to load Profit Center",
          description: error?.message || "Please try again later.",
          status: "error",
          duration: 4000,
        });
      }
    },
    [companyCode, toast, workflowProcess],
  );

  // --- Fetch Profit Center ---
  useEffect(() => {
    if (isLevel && data?.some((item: any) => item.profitCenter)) return;
    fetchProfitCenterOptions();
  }, [fetchProfitCenterOptions, isLevel, data]);

  const fetchGlAccountsOptions = useCallback(
    async (isManual = false) => {
      if (!companyCode?.value) return;

      try {
        const payload = {
          type: "getGlAccount",
          companyCode: companyCode?.value,
          ...workflowProcess,
        };
        const response: any = await appRequest(
          "user",
          "masterFinancialApi",
          payload,
        );
        if (response?.status === "success" && Array.isArray(response?.data)) {
          const options = response.data.map((item: any) => ({
            label: item.label || `${item.glAccount} - ${item.description}`,
            value: item.glAccount,
            description: item.description,
          }));
          setGlAccountsOptions(options);
          if (isManual) {
            toast({
              title: "GL Accounts Refreshed",
              status: "success",
              duration: 2000,
              isClosable: true,
            });
          }
        }
      } catch (error: any) {
        toast({
          title: "Failed to load GL Accounts",
          description: error?.message || "Please try again later.",
          status: "error",
          duration: 4000,
        });
      }
    },
    [companyCode, toast, workflowProcess],
  );

  // --- Fetch GL Accounts ---
  useEffect(() => {
    if (!companyCode || (isLevel && data?.some((item: any) => item.glAccount)))
      return;
    fetchGlAccountsOptions();
  }, [fetchGlAccountsOptions, companyCode, isLevel, data]);

  const fetchPlantCodeOptions = useCallback(
    async (isManual = false) => {
      if (!companyCode?.value) return;

      try {
        const payload = {
          type: "getPlantCode",
          companyCode: companyCode?.value,
          ...workflowProcess,
        };
        const response: any = await appRequest(
          "user",
          "masterFinancialApi",
          payload,
        );
        if (response?.status === "success" && Array.isArray(response?.data)) {
          const options = response.data.map((code: any) => ({
            label: code,
            value: code,
          }));

          setPlantCodeOptions(options);



          if (isManual) {
            toast({
              title: "Plant Codes Refreshed",
              status: "success",
              duration: 2000,
              isClosable: true,
            });
          }
        }
      } catch (error: any) {
        toast({
          title: "Failed to load Plant Code",
          description: error?.message || "Please try again later.",
          status: "error",
          duration: 4000,
        });
      }
    },
    [companyCode, toast, workflowProcess, formData?.plantCode, setFormData],
  );

  // --- Fetch Plant Codes ---
  useEffect(() => {
    fetchPlantCodeOptions();
  }, [fetchPlantCodeOptions]);


  const fetchTaxCodeOptions = useCallback(
    async (isManual = false) => {
      if (!companyCode?.value) return;

      try {
        const res: any = await appRequest("taxcode", "getAll", {
          page: 1,
          limit: 500,
          process: workflowProcess?.processName,
          companyCode: companyCode?.value,
        });

        if (res?.status === "success") {
          setTaxCodeOptions(res?.data?.data || []);
          if (isManual) {
            toast({
              title: "Tax Codes Refreshed",
              status: "success",
              duration: 2000,
              isClosable: true,
            });
          }
        }
      } catch (err: any) {
        console.error("Tax Code fetch fail:", err);
      }
    },
    [companyCode, toast, workflowProcess],
  );

  useEffect(() => {
    fetchTaxCodeOptions();
  }, [fetchTaxCodeOptions]);



  // --- Cascading handler for Profit Center ---
  const fetchCostCenterOptions = useCallback(
    async (index: number, profitValue: any, isManual = false) => {
      if (!companyCode?.value || !profitValue) return;

      const cacheKey = `${companyCode.value}-${profitValue}`;
      let costOptions: any[] = isManual ? [] : (costCenterCache[cacheKey] || []);

      if (!costOptions.length) {
        try {
          const payload = {
            type: "getCostCenter",
            companyCode: companyCode.value,
            profitCenter: profitValue,
            ...workflowProcess,
          };
          const response: any = await appRequest(
            "user",
            "masterFinancialApi",
            payload,
          );
          if (response?.status === "success" && Array.isArray(response?.data)) {
            costOptions = response.data.map((cc: any) => ({
              label: cc.label,
              value: cc.costCenter,
              description: cc.costCenterDescription,
            }));
            setCostCenterCache((prev) => ({
              ...prev,
              [cacheKey]: costOptions,
            }));

            if (isManual) {
              const updatedLineItems = lineItems.map((itm: any, i: number) =>
                i === index ? { ...itm, costCenterOptions: costOptions } : itm
              );
              setLineItems(updatedLineItems);
              toast({
                title: "Cost Centers Refreshed",
                status: "success",
                duration: 2000,
                isClosable: true,
              });
            }
          } else {
            costOptions = [];
          }
        } catch (error: any) {
          toast({
            title: "Failed to load Cost Centers",
            description: error?.message || "Please try again later.",
            status: "error",
            duration: 4000,
          });
          costOptions = [];
        }
      }
      return costOptions;
    },
    [companyCode, costCenterCache, workflowProcess, toast, lineItems, setLineItems]
  );

  const handleProfitCenterChange = useCallback(
    async (index: number, value: any) => {
      if (!value || !companyCode || isLevel) return;
      const profitValue = value.value;

      const costOptions = await fetchCostCenterOptions(index, profitValue) || [];

      const updatedLineItems = lineItems.map((itm: any, i: number) =>
        i === index
          ? (workflowProcess?.processName === "tillomed" && accountDetails?.level === "level-2")
            ? { ...itm, profitCenter: value }
            : {
              ...itm,
              profitCenter: value,
              costCenter: null,
              businessArea: null,
              glAccount: null,
              internalOrder: null,
              costCenterOptions: costOptions,
              businessAreaOptions: [],
              internalOrderOptions: [],
            }
          : itm,
      );
      setLineItems(updatedLineItems);
    },
    [companyCode, fetchCostCenterOptions, lineItems, isLevel],
  );

  // PROFIT CENTER → COST CENTER → BUSINESS AREA (auto chain)
  // const handleProfitCenterChange = useCallback(
  //   async (index: number, value: any) => {
  //     if (!value || !companyCode || isLevel) return;

  //     const profitValue = value.value;
  //     const cacheKey = `${companyCode.value}-${profitValue}`;
  //     let costOptions: any[] = costCenterCache[cacheKey] || [];

  //     // Fetch Cost Centers if not cached
  //     if (!costOptions.length) {
  //       try {
  //         const payload = {
  //           type: "getCostCenter",
  //           companyCode: companyCode.value,
  //           profitCenter: profitValue,
  //           ...workflowProcess,
  //         };
  //         const response: any = await appRequest("user", "masterFinancialApi", payload);

  //         if (response?.status === "success" && Array.isArray(response?.data)) {
  //           costOptions = response.data.map((cc: any) => ({
  //             label: cc.label,
  //             value: cc.costCenter,
  //             description: cc.costCenterDescription,
  //           }));
  //           setCostCenterCache((prev) => ({ ...prev, [cacheKey]: costOptions }));
  //         } else {
  //           costOptions = [];
  //         }
  //       } catch (error: any) {
  //         toast({ title: "Failed to load Cost Centers", status: "error" });
  //         costOptions = [];
  //       }
  //     }

  //     const defaultCostCenter = costOptions[0] ?? null;

  //     // Update line item with Profit Center + auto-selected Cost Center
  //     setLineItems((prev : any) =>
  //       prev.map((itm : any, i : any) =>
  //         i === index
  //           ? {
  //               ...itm,
  //               profitCenter: value,
  //               costCenter: defaultCostCenter,
  //               costCenterOptions: costOptions,
  //               businessArea: null,
  //               businessAreaOptions: [],
  //               glAccount: null,
  //               internalOrder: null,
  //               internalOrderOptions: [],
  //             }
  //           : itm
  //       )
  //     );

  //     // CHAIN: If a default Cost Center exists → trigger Business Area load + auto-select
  //     if (defaultCostCenter) {
  //       // Reuse the same logic as handleCostCenterChange but inline
  //       const costValue = defaultCostCenter.value;
  //       const baCacheKey = `${companyCode.value}-${profitValue}-${costValue}`;
  //       let baOptions: any[] = businessAreaCache[baCacheKey] || [];

  //       if (!baOptions.length) {
  //         try {
  //           const payload = {
  //             type: "getBusinessArea",
  //             companyCode: companyCode.value,
  //             profitCenter: profitValue,
  //             costCenter: costValue,
  //             ...workflowProcess,
  //           };
  //           const response: any = await appRequest("user", "masterFinancialApi", payload);

  //           if (response?.status === "success" && Array.isArray(response?.data)) {
  //             baOptions = response.data.map((ba: string) => ({ label: ba, value: ba }));
  //             setBusinessAreaCache((prev) => ({ ...prev, [baCacheKey]: baOptions }));
  //           }
  //         } catch (error: any) {
  //           toast({ title: "Failed to load Business Areas", status: "error" });
  //         }
  //       }

  //       const defaultBusinessArea = baOptions[0] ?? null;

  //       // Final update: also auto-select Business Area
  //       setLineItems((prev : any) =>
  //         prev.map((itm : any, i : any) =>
  //           i === index
  //             ? {
  //                 ...itm,
  //                 businessArea: defaultBusinessArea,
  //                 businessAreaOptions: baOptions,
  //               }
  //             : itm
  //         )
  //       );
  //     }
  //   },
  //   [companyCode, costCenterCache, businessAreaCache, toast, isLevel, workflowProcess]
  // );

  // --- Cascading handler for Cost Center ---
  const fetchBusinessAreaOptions = useCallback(
    async (index: number, costValue: any, profitValue: any, isManual = false) => {
      if (!companyCode?.value || !costValue || !profitValue) return;

      const cacheKey = `${companyCode.value}-${profitValue}-${costValue}`;
      let baOptions: any[] = isManual ? [] : (businessAreaCache[cacheKey] || []);

      if (!baOptions.length) {
        try {
          const payload = {
            type: "getBusinessArea",
            companyCode: companyCode.value,
            profitCenter: profitValue,
            costCenter: costValue,
            ...workflowProcess,
          };
          const response: any = await appRequest(
            "user",
            "masterFinancialApi",
            payload,
          );
          if (response?.status === "success" && Array.isArray(response?.data)) {
            baOptions = response.data.map((ba: string) => ({
              label: ba,
              value: ba,
            }));
            setBusinessAreaCache((prev) => ({
              ...prev,
              [cacheKey]: baOptions,
            }));
            if (isManual) {
              const updatedLineItems = lineItems.map((itm: any, i: number) =>
                i === index ? { ...itm, businessAreaOptions: baOptions } : itm
              );
              setLineItems(updatedLineItems);
              toast({
                title: "Business Areas Refreshed",
                status: "success",
                duration: 2000,
                isClosable: true,
              });
            }
          } else {
            baOptions = [];
          }
        } catch (error: any) {
          toast({
            title: "Failed to load Business Areas",
            description: error?.message || "Please try again later.",
            status: "error",
            duration: 4000,
          });
          baOptions = [];
        }
      }
      return baOptions;
    },
    [companyCode, businessAreaCache, workflowProcess, toast, lineItems, setLineItems]
  );

  const handleCostCenterChange = useCallback(
    async (index: number, value: any) => {
      if (!value || !companyCode || !lineItems[index]?.profitCenter || isLevel)
        return;
      const profitValue = lineItems[index].profitCenter.value;
      const costValue = value.value;

      const baOptions = await fetchBusinessAreaOptions(index, costValue, profitValue) || [];

      const updatedLineItems = lineItems.map((itm: any, i: number) =>
        i === index
          ? {
            ...itm,
            costCenter: value,
            businessArea: null,
            glAccount: null,
            internalOrder: null,
            businessAreaOptions: baOptions,
            internalOrderOptions: [],
          }
          : itm,
      );
      setLineItems(updatedLineItems);
    },
    [companyCode, fetchBusinessAreaOptions, lineItems, isLevel],
  );

  // COST CENTER → BUSINESS AREA (auto-select first)
  // const handleCostCenterChange = useCallback(
  //   async (index: number, value: any) => {
  //     if (!value || !companyCode || !lineItems[index]?.profitCenter || isLevel) return;

  //     const profitValue = lineItems[index].profitCenter.value;
  //     const costValue = value.value;
  //     const cacheKey = `${companyCode.value}-${profitValue}-${costValue}`;
  //     let baOptions: any[] = businessAreaCache[cacheKey] || [];

  //     if (!baOptions.length) {
  //       try {
  //         const payload = {
  //           type: "getBusinessArea",
  //           companyCode: companyCode.value,
  //           profitCenter: profitValue,
  //           costCenter: costValue,
  //           ...workflowProcess,
  //         };
  //         const response: any = await appRequest("user", "masterFinancialApi", payload);

  //         if (response?.status === "success" && Array.isArray(response?.data)) {
  //           baOptions = response.data.map((ba: string) => ({ label: ba, value: ba }));
  //           setBusinessAreaCache((prev) => ({ ...prev, [cacheKey]: baOptions }));
  //         }
  //       } catch (error: any) {
  //         toast({ title: "Failed to load Business Areas", status: "error" });
  //       }
  //     }

  //     const defaultBusinessArea = baOptions[0] ?? null;

  //     setLineItems((prev : any) =>
  //       prev.map((itm : any, i : number) =>
  //         i === index
  //           ? {
  //               ...itm,
  //               costCenter: value,
  //               businessArea: defaultBusinessArea,
  //               businessAreaOptions: baOptions,
  //               glAccount: null,
  //               internalOrder: null,
  //               internalOrderOptions: [],
  //             }
  //           : itm
  //       )
  //     );
  //   },
  //   [companyCode, businessAreaCache, lineItems, toast, isLevel, workflowProcess]
  // );

  // const handleGlAccountChange = useCallback(
  //   async (index: number, value: any) => {
  //     if (!value || !companyCode || isLevel) return;
  //     const glAccountValue = value.value;
  //     const currentLineItem = lineItems[index];

  //     // Optional: profitCenter may or may not exist
  //     const profitCenterValue = currentLineItem?.profitCenter?.value || null;

  //     const cacheKey = `${companyCode.value}-${glAccountValue}`;
  //     let ioOptions: any[] = internalOrderCache[cacheKey] || [];
  //     if (!ioOptions.length) {
  //       try {
  //         const payload = {
  //           type: "getInternalOrder",
  //           companyCode: companyCode.value,
  //           profitCenter: profitCenterValue,
  //           glAccount: glAccountValue,
  //           ...workflowProcess,
  //         };
  //         const response: any = await appRequest(
  //           "user",
  //           "masterFinancialApi",
  //           payload
  //         );
  //         if (response?.status === "success" && Array.isArray(response?.data)) {
  //           ioOptions = response.data.map((io: string) => ({
  //             label: io,
  //             value: io,
  //           }));
  //           setInternalOrderCache((prev) => ({
  //             ...prev,
  //             [cacheKey]: ioOptions,
  //           }));
  //         } else {
  //           ioOptions = [];
  //         }
  //       } catch (error: any) {
  //         toast({
  //           title: "Failed to load Internal Orders",
  //           description: error?.message || "Please try again later.",
  //           status: "error",
  //           duration: 4000,
  //         });
  //         ioOptions = [];
  //       }
  //     }
  //     const updatedLineItems = lineItems.map((itm: any, i: number) =>
  //       i === index
  //         ? {
  //             ...itm,
  //             glAccount: value,
  //             internalOrder: null,
  //             internalOrderOptions: ioOptions,
  //           }
  //         : itm
  //     );
  //     setLineItems(updatedLineItems);
  //   },
  //   [companyCode, internalOrderCache, lineItems, toast, isLevel]
  // );

  console.log('the dynamic schema modal are', dynamicSchemaData)

  const fetchInternalOrderOptions = useCallback(
    async (index: number, glAccountValue: any, profitCenterValue: any, isManual = false) => {
      if (!companyCode?.value || !glAccountValue) return;

      const cacheKey = `${companyCode.value}-${profitCenterValue ?? "NA"}-${glAccountValue}`;
      let ioOptions: any[] = isManual ? [] : (internalOrderCache[cacheKey] || []);

      if (!ioOptions.length) {
        try {
          const payload: any = {
            type: "getInternalOrder",
            companyCode: companyCode.value,
            glAccount: glAccountValue,
            ...workflowProcess,
          };

          if (profitCenterValue) {
            payload.profitCenter = profitCenterValue;
          }

          const response: any = await appRequest(
            "user",
            "masterFinancialApi",
            payload,
          );

          if (response?.status === "success" && Array.isArray(response?.data)) {
            ioOptions = response.data.map((io: string) => ({
              label: io,
              value: io,
            }));

            setInternalOrderCache((prev) => ({
              ...prev,
              [cacheKey]: ioOptions,
            }));

            if (isManual) {
              const updatedLineItems = lineItems.map((itm: any, i: number) =>
                i === index ? { ...itm, internalOrderOptions: ioOptions } : itm
              );
              setLineItems(updatedLineItems);
              toast({
                title: "Internal Orders Refreshed",
                status: "success",
                duration: 2000,
                isClosable: true,
              });
            }
          } else {
            ioOptions = [];
          }
        } catch (error: any) {
          toast({
            title: "Failed to load Internal Orders",
            description: error?.message || "Please try again later.",
            status: "error",
            duration: 4000,
          });
          ioOptions = [];
        }
      }
      return ioOptions;
    },
    [companyCode, internalOrderCache, workflowProcess, toast, lineItems, setLineItems]
  );

  const handleGlAccountChange = useCallback(
    async (index: number, value: any) => {
      if (!value || !companyCode || isLevel || !lineItems[index]) return;

      const currentLineItem = lineItems[index];
      const glAccountValue = value.value;
      const profitCenterValue = currentLineItem?.profitCenter?.value || null;

      const ioOptions = await fetchInternalOrderOptions(index, glAccountValue, profitCenterValue) || [];

      setLineItems((prev: any[]) =>
        prev.map((itm, i) =>
          i === index
            ? {
              ...itm,
              glAccount: value,
              internalOrder: null,
              internalOrderOptions: ioOptions,
            }
            : itm,
        ),
      );
    },
    [
      companyCode,
      fetchInternalOrderOptions,
      lineItems,
      isLevel,
    ],
  );

  const fetchBusinessPlaceOptions = useCallback(
    async (index: number, plantCodeValue: any, isManual = false) => {
      if (!companyCode?.value || !plantCodeValue) return;

      const cacheKey = `${companyCode.value}-${plantCodeValue}`;
      let bpOptions: any[] = isManual ? [] : (businessPlaceCache[cacheKey] || []);

      if (!bpOptions.length) {
        try {
          const payload = {
            type: "getBusinessPlace",
            plantCode: plantCodeValue,
            companyCode: companyCode.value,
            // vendorCode: selectedVendor?.value, // Optional if needed
            ...workflowProcess,
          };
          const response: any = await appRequest(
            "user",
            "masterFinancialApi",
            payload,
          );
          if (response?.status === "success" && Array.isArray(response?.data)) {
            bpOptions = response.data.map((bp: string) => ({
              label: bp,
              value: bp,
            }));
            setBusinessPlaceCache((prev) => ({
              ...prev,
              [cacheKey]: bpOptions,
            }));
            if (isManual) {
              const updatedLineItems = lineItems.map((itm: any, i: number) =>
                i === index ? { ...itm, businessPlaceOptions: bpOptions } : itm
              );
              setLineItems(updatedLineItems);
              toast({
                title: "Business Places Refreshed",
                status: "success",
                duration: 2000,
                isClosable: true,
              });
            }
          } else {
            bpOptions = [];
          }
        } catch (error: any) {
          toast({
            title: "Failed to load Business Places",
            description: error?.message || "Please try again later.",
            status: "error",
            duration: 4000,
          });
          bpOptions = [];
        }
      }
      return bpOptions;
    },
    [companyCode, businessPlaceCache, workflowProcess, toast, lineItems, setLineItems]
  );

  const handlePlantCodeChange = useCallback(
    async (index: number, value: any) => {
      if (!value || !companyCode || isLevel || !lineItems[index]) return;

      const plantCodeValue = value.value;
      const bpOptions = await fetchBusinessPlaceOptions(index, plantCodeValue) || [];

      const updatedLineItems = lineItems.map((itm: any, i: number) =>
        i === index
          ? {
            ...itm,
            plantCode: value,
            businessPlace: null,
            businessPlaceOptions: bpOptions,
          }
          : itm,
      );
      setLineItems(updatedLineItems);
    },
    [companyCode, fetchBusinessPlaceOptions, lineItems, isLevel],
  );

  //   const handleGlAccountChange = useCallback(
  //   async (index: number, value: any) => {
  //     // Basic guards — these are required
  //     if (!value || !companyCode || isLevel || !lineItems[index]) return;

  //     const currentLineItem = lineItems[index];
  //     const glAccountValue = value.value;

  //     // Optional: profitCenter may or may not exist
  //     const profitCenterValue = currentLineItem?.profitCenter?.value || null;

  //     // Cache key: include profitCenter only if it exists
  //     const cacheKey = profitCenterValue
  //       ? `${companyCode.value}-${profitCenterValue}-${glAccountValue}`
  //       : `${companyCode.value}-null-${glAccountValue}`;

  //     let ioOptions: any[] = internalOrderCache[cacheKey] || [];

  //     // Only fetch if not cached
  //     if (!ioOptions.length) {
  //       try {
  //         const payload: any = {
  //           type: "getInternalOrder",
  //           companyCode: companyCode.value,
  //           glAccount: glAccountValue,
  //           ...workflowProcess,
  //         };

  //         // Only add profitCenter if it actually exists
  //         if (profitCenterValue) {
  //           payload.profitCenter = profitCenterValue;
  //         }

  //         const response: any = await appRequest("user", "masterFinancialApi", payload);

  //         if (response?.status === "success" && Array.isArray(response?.data)) {
  //           ioOptions = response.data.map((io: string) => ({
  //             label: io,
  //             value: io,
  //           }));

  //           setInternalOrderCache((prev) => ({
  //             ...prev,
  //             [cacheKey]: ioOptions,
  //           }));
  //         } else {
  //           ioOptions = [];
  //         }
  //       } catch (error) {
  //         // Silent fallback — never break the UI
  //         ioOptions = [];
  //       }
  //     }

  //     // Auto-select first Internal Order if available
  //     const defaultInternalOrder = ioOptions[0] ?? null;

  //     setLineItems((prev : any) =>
  //       prev.map((itm : any, i : number) =>
  //         i === index
  //           ? {
  //               ...itm,
  //               glAccount: value,
  //               internalOrder: defaultInternalOrder,
  //               internalOrderOptions: ioOptions,
  //             }
  //           : itm
  //       )
  //     );
  //   },
  //   [
  //     companyCode,
  //     internalOrderCache,
  //     lineItems,
  //     isLevel,
  //     workflowProcess,
  //   ]
  // );

  // --- Delete line item ---

  const deleteLineItem = useCallback(
    (index: number) => {
      const updated = lineItems.filter((_: any, i: number) => i !== index);
      setLineItems(updated);
    },
    [lineItems, setLineItems],
  );

  // --- Initialize line items and formData ---
  useEffect(() => {
    if (lineItems.length === 0 && data?.length > 0) {
      const initialItems = data.map((item: any) => ({
        ...item,
        description: item?.description || item.Item_Description,
        companyCode: companyCode,
        businessArea:
          typeof item.businessArea === "string" && item.businessArea
            ? { label: item.businessArea, value: item.businessArea }
            : item.businessArea || null,
        costCenter:
          typeof item.costCenter === "string" && item.costCenter
            ? { label: item.costCenter, value: item.costCenter }
            : item.costCenter || null,
        taxCode:
          typeof item.taxCode === "string" && item.taxCode
            ? { label: item.taxCode, value: item.taxCode }
            : item.taxCode || null,
        glAccount:
          typeof item.glAccount === "string" && item.glAccount
            ? { label: item.glAccount, value: item.glAccount }
            : item.glAccount || null,
        internalOrder:
          typeof item.internalOrder === "string" && item.internalOrder
            ? { label: item.internalOrder, value: item.internalOrder }
            : item.internalOrder || null,
        profitCenter:
          typeof item.profitCenter === "string" && item.profitCenter
            ? { label: item.profitCenter, value: item.profitCenter }
            : item.profitCenter || null,
        line_item_id: item.line_item_id || uuidv4(),
        line_item_time: item.line_item_time || new Date().toISOString(),
        plantCode:
          typeof item.plantCode === "string" && item.plantCode
            ? { label: item.plantCode, value: item.plantCode }
            : item.plantCode || null,
        businessPlace:
          typeof item.businessPlace === "string" && item.businessPlace
            ? { label: item.businessPlace, value: item.businessPlace }
            : item.businessPlace || null,
        costCenterOptions: [],
        businessAreaOptions: [],
        internalOrderOptions: [],
        businessPlaceOptions: [],
      }));

      setLineItems(initialItems);
      setFormData((prev: any) => ({
        ...prev,
        remark: prev.remark || data.remark || "",
        companyCode: companyCode || prev.companyCode || null,

        gstVendorCode: prev.gstVendorCode || null,
        isTdsApplicable: prev.isTdsApplicable ?? data.isTdsApplicable ?? false,
        tdsTaxCode: prev.tdsTaxCode ?? data.tdsTaxCode ?? null,
        tdsBasicAmount: prev.tdsBasicAmount ?? data.tdsBasicAmount ?? "",
        isExchangeRateApplicable:
          prev.isExchangeRateApplicable ??
          data.isExchangeRateApplicable ??
          false,
        exchangeRate: prev.exchangeRate ?? data.exchangeRate ?? "",
        lineItems: initialItems,
      }));
    }
  }, [data, companyCode, lineItems.length, setFormData, setLineItems]);

  console.log("the form data are", formData);
  const filteredApprovers = fetchDomesticApprovers?.filter(
    (it: any) => it?.approvers?.[0]?.value === accountDetails?.userId,
  );

  useEffect(() => {
    if (!formData.domesticInitiator) {
      setFormData((prev: any) => ({
        ...prev,
        domesticInitiator: {
          label: `${accountDetails?.username}`,
          value: accountDetails?.userId,
        },
      }));
    }
  }, []);

  console.log('the assign document are', assignDocument)

  return (
    <Box
      ref={scrollContainerRef}
      flex="1"
      overflowY="auto"
      px={{ base: 4, md: 6 }}
      py={4}
      maxW={{ base: "100%", md: "100%" }}
      mx="auto"
      w="100%"
      maxH={{ base: "70vh", md: "72vh" }}
      bg="white"
      borderRadius="md"
      boxShadow="lg"
    >
      <VStack spacing={4} align="stretch">
        {/* General Information Section */}
        <Box>
          <Flex justify="space-between" align="center">
            <Heading size="sm" color="gray.700">
              General Information
            </Heading>
            <IconButton
              aria-label="Toggle General Information"
              icon={isGeneralOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
              onClick={toggleGeneral}
              size="sm"
              variant="ghost"
            />
          </Flex>
          <Collapse in={isGeneralOpen} animateOpacity>
            <HStack spacing={3} flexWrap="wrap" mt={2}>
              <Box flex={{ base: "1 1 100%", md: "1 1 45%" }} minW="180px">
                <CustomInput
                  name="companyCode"
                  label="Company Code"
                  type="select"
                  options={companyCodeOptions}
                  value={companyCode || ""}
                  onChange={(e) => {
                    setCompanyCode(e);
                    setFormData((prev: any) => ({ ...prev, companyCode: e }));
                  }}
                  disabled={(accountDetails?.level === "level-2" && workflowProcess?.processName === "domestic") ? true : isDisabled}
                  // disabled={isDisabled}
                  isBoxSelect
                  isRequired={true}
                />
              </Box>
            </HStack>
          </Collapse>
        </Box>

        <Divider borderColor="gray.200" />

        {/* Vendor Information Section */}
        <Box>
          <Flex justify="space-between" align="center">
            <Heading size="sm" color="gray.700">
              Vendor Information
            </Heading>
            <IconButton
              aria-label="Toggle Vendor Information"
              icon={isVendorOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
              onClick={toggleVendor}
              size="sm"
              variant="ghost"
            />
          </Flex>
          <Collapse in={isVendorOpen} animateOpacity>
            <Box mt={2}>
              <Flex
                direction={{ base: "column", md: "row" }}
                gap={4}
                align="flex-end"
              >
                {/* Vendor Code Select (only if options exist) */}
                {gstVendorCodeOptions.length > 0 && (
                  <Box flex={{ base: "1 1 100%", md: "1 1 45%" }} minW="180px">
                    <CustomInput
                      name="gstVendorCode"
                      label="Vendor Code"
                      type="select"
                      options={gstVendorCodeOptions}
                      value={selectedVendor}
                      onChange={(e: any) => {
                        setSelectedVendor(e);
                        setFormData((prev: any) => ({
                          ...prev,
                          gstVendorCode: e,
                        }));
                      }}
                      disabled={(accountDetails?.level === "level-2" && workflowProcess?.processName === "domestic") ? true : isDisabled}
                      isBoxSelect
                      isRequired={true}
                    />
                  </Box>
                )}

                {/* Search Vendor Input + Button */}
                <Flex flex="1" gap={3} align="flex-end">
                  <Box flex="1" minW="180px">
                    <CustomInput
                      name="vendorSearch"
                      label="Search Vendor Code By Name"
                      placeholder="Enter vendor name..."
                      value={vendorSearch}
                      onChange={(e: any) => setVendorSearch(e.target.value)}
                    />
                  </Box>
                  <Button
                    onClick={handleVendorSearch}
                    isLoading={isSearching}
                    colorScheme="blue"
                    // size={{ base: "md", md: "lg" }}
                    height="45px"
                    isDisabled={(accountDetails?.level === "level-2" && workflowProcess?.processName === "domestic") ? true : isDisabled || !vendorSearch.trim()}
                  >
                    Search
                  </Button>
                </Flex>
              </Flex>

              {extractVendorAddress(formData.gstVendorCode) ? (
                <Box
                  mt={2}
                  p={2}
                  bg="gray.50"
                  borderRadius="md"
                  border="1px solid"
                  borderColor="gray.200"
                  fontSize="sm"
                >
                  <Text fontWeight="medium" color="gray.700">
                    Vendor Address
                  </Text>
                  <Text color="gray.600" fontStyle="italic" mt={1}>
                    {extractVendorAddress(formData.gstVendorCode)}
                  </Text>
                </Box>
              ) : null}
            </Box>
          </Collapse>
        </Box>
        <Divider borderColor="gray.200" />

        {/* Invoice Details Section */}
        <Box>
          <Flex justify="space-between" align="center">
            <Heading size="sm" color="gray.700">
              Invoice Details
            </Heading>
            <IconButton
              aria-label="Toggle Invoice Details"
              icon={isInvoiceOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
              onClick={toggleInvoice}
              size="sm"
              variant="ghost"
            />
          </Flex>
          <Collapse in={isInvoiceOpen} animateOpacity>
            <HStack spacing={3} flexWrap="wrap" mt={2}>
              <Box flex={{ base: "1 1 100%", md: "1 1 45%" }} minW="180px">
                <CustomInput
                  name="invoiceType"
                  label="Invoice Type"
                  type="select"
                  options={invoiceTypeOptions}
                  value={formData.invoiceType}
                  onChange={(e: any) => {
                    setFormData((prev: any) => ({ ...prev, invoiceType: e }));
                  }}
                  disabled={isDisabled}
                  isBoxSelect
                  isRequired={true}
                />
              </Box>
              <Box
                display={
                  accountDetails?.level === `level-${workFlowData?.levels}` ||
                    getFiUser(workFlowData?.processName, accountDetails?.level)
                    ? undefined
                    : "none"
                }
                flex={{ base: "1 1 100%", md: "1 1 45%" }}
                minW="180px"
              >
                <CustomInput
                  name="postingDate"
                  label="Posting Date"
                  type="date"
                  value={formData.postingDate}
                  onChange={(e: any) => {
                    setFormData((prev: any) => ({
                      ...prev,
                      postingDate: e.target.value,
                    }));
                  }}
                  maxDate={new Date().toISOString().split("T")[0]}
                  disabled={
                    (getFiUser(workflowProcess?.processName, accountDetails?.level) || accountDetails?.level === `level-${workFlowData?.levels}`) &&
                      ["tillomed", "marcan"].includes(
                        workflowProcess?.processName,
                      )
                      ? false
                      : isDisabled
                  }
                  isBoxSelect
                />
              </Box>
              <Box
                style={{
                  display: ["tillomed"].includes(
                    workflowProcess.processName,
                  )
                    ? "none"
                    : undefined,
                }}
                flex={{ base: "1 1 100%", md: "1 1 45%" }}
                minW="180px"
              >
                <CustomInput
                  name="baseLineDate"
                  label="Baseline Date"
                  type="date"
                  value={formData.baseLineDate}
                  onChange={(e: any) => {
                    setFormData((prev: any) => ({
                      ...prev,
                      baseLineDate: e.target.value,
                    }));
                  }}
                  disabled={isDisabled}
                  isBoxSelect
                  maxDate={new Date().toISOString().split("T")[0]}
                />
              </Box>
              <Box flex={{ base: "1 1 100%", md: "1 1 45%" }} minW="180px">
                <CustomInput
                  name="referenceKey1"
                  label="Reference Key 1"
                  type="text"
                  value={formData.referenceKey1}
                  onChange={(e: any) => {
                    setFormData((prev: any) => ({
                      ...prev,
                      referenceKey1: e.target.value,
                    }));
                  }}
                  disabled={isDisabled}
                  placeholder="Enter reference key 1"
                />
              </Box>
              <Box flex={{ base: "1 1 100%", md: "1 1 45%" }} minW="180px">
                <CustomInput
                  name="referenceKey2"
                  label="Reference Key 2"
                  type="text"
                  value={formData.referenceKey2}
                  onChange={(e: any) => {
                    setFormData((prev: any) => ({
                      ...prev,
                      referenceKey2: e.target.value,
                    }));
                  }}
                  disabled={isDisabled}
                  placeholder="Enter reference key 2"
                />
              </Box>
              <Box flex={{ base: "1 1 100%", md: "1 1 45%" }} minW="180px">
                <CustomInput
                  name="referenceKey3"
                  label="Reference Key 3"
                  type="text"
                  value={formData.referenceKey3}
                  onChange={(e: any) => {
                    setFormData((prev: any) => ({
                      ...prev,
                      referenceKey3: e.target.value,
                    }));
                  }}
                  disabled={isDisabled}
                  placeholder="Enter reference key 3"
                />
              </Box>
              <Box flex={{ base: "1 1 100%", md: "1 1 45%" }} minW="180px">
                <CustomInput
                  name="vendorText"
                  label="Vendor Text"
                  type="text"
                  value={formData.vendorText}
                  onChange={(e: any) => {
                    setFormData((prev: any) => ({
                      ...prev,
                      vendorText: e.target.value,
                    }));
                  }}
                  disabled={isDisabled}
                  placeholder="Enter vendor text"
                  isBoxSelect
                  isRequired={true}
                />
              </Box>

              {workflowProcess?.processName !== "marcan" && (
                <Box flex={{ base: "1 1 100%", md: "1 1 45%" }} minW="180px">
                  <CustomInput
                    name="taxJurisdiction"
                    label="Tax Jurisdiction"
                    type="text"
                    value={formData.taxJurisdiction}
                    onChange={(e: any) => {
                      setFormData((prev: any) => ({
                        ...prev,
                        taxJurisdiction: e.target.value,
                      }));
                    }}
                    disabled={isDisabled}
                    placeholder="Enter tax jurisdiction"
                    isBoxSelect
                  />
                </Box>
              )}
            </HStack>
          </Collapse>
        </Box>

        <Divider borderColor="gray.200" />

        {/* Tax and Exchange Rate Section */}
        <Box display={accountDetails?.level === "level-1" ? 'none' : undefined}>
          <Flex justify="space-between" align="center">
            <Heading size="sm" color="gray.700">
              Tax and Exchange Rate
            </Heading>
            <IconButton
              aria-label="Toggle Tax and Exchange Rate"
              icon={isTaxOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
              onClick={toggleTax}
              size="sm"
              variant="ghost"
            />
          </Flex>
          <Collapse in={isTaxOpen} animateOpacity>
            <VStack spacing={5} mt={3} align="stretch">
              {/* TDS Applicable Toggle */}
              <FormControl display="flex" alignItems="center">
                <FormLabel
                  htmlFor="tds-applicable"
                  mb="0"
                  fontWeight="semibold"
                  fontSize="sm"
                  color="gray.700"
                >
                  TDS Applicable
                </FormLabel>
                <Switch
                  id="tds-applicable"
                  isChecked={formData.isTdsApplicable}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setFormData((prev: any) => ({
                      ...prev,
                      isTdsApplicable: isChecked,
                      tdsTaxCode: isChecked ? prev.tdsTaxCode : null,
                      tdsBasicAmount: isChecked ? prev.tdsBasicAmount : "",
                    }));
                  }}
                  disabled={isDisabled}
                  colorScheme="blue"
                  size="md"
                />
              </FormControl>

              {/* ================================
                        TDS MAIN SECTION
              ================================= */}
              {formData.isTdsApplicable && (
                <Box>
                  {/* SECTION TITLE */}
                  <Box
                    pb={3}
                    borderBottom="1px solid"
                    borderColor="gray.200"
                    mb={4}
                  >
                    <Heading size="sm" color="blue.700">
                      TDS Type Selection
                    </Heading>
                  </Box>

                  {/* Radio Selection */}
                  <RadioGroup
                    value={formData.tdsSectionType}
                    onChange={(value) =>
                      setFormData((prev: any) => ({
                        ...prev,
                        tdsSectionType: value,
                      }))
                    }
                    mb={4}
                  >
                    <HStack spacing={8}>
                      <Radio value="tds">Through TDS</Radio>
                      <Radio value="gl">Through GL Account</Radio>
                    </HStack>
                  </RadioGroup>

                  {/* ============================
                            TDS FIELDS
                  ============================ */}
                  {formData?.tdsSectionType === "tds" && (
                    <Flex flexDirection="column" mt={5} flexWrap="wrap">
                    <HStack spacing={4} mt={5} flexWrap="wrap">
                      <Box flex={{ base: "1 1 100%", md: "1 1 45%" }}>
                        <CustomInput
                          name="tdsTaxCode"
                          label="TDS Tax Code 1"
                          type="select"
                          options={addNA(tdsTaxCodeOptions)}
                          value={formData.tdsTaxCode}
                          onChange={(e: any) => {
                            setFormData((prev: any) => ({
                              ...prev,
                              tdsTaxCode: e,
                            }));
                          }}
                          disabled={isDisabled}
                          isBoxSelect
                          isRequired={true}
                        />
                      </Box>

                      <Box flex={{ base: "1 1 100%", md: "1 1 45%" }}>
                        <CustomInput
                          name="tdsBasicAmount"
                          label="TDS Basic Amount 1"
                          type="number"
                          value={formData.tdsBasicAmount}
                          onChange={(e: any) => {
                            setFormData((prev: any) => ({
                              ...prev,
                              tdsBasicAmount: e.target.value,
                            }));
                          }}
                          disabled={isDisabled}
                          placeholder="Enter TDS basic amount"
                          isBoxSelect
                          isRequired={true}
                        />
                      </Box>
                    </HStack>
                    <HStack spacing={4} mt={5} flexWrap="wrap">
                                          <Box flex={{ base: "1 1 100%", md: "1 1 45%" }}>
                                            <CustomInput
                                              name="tdsTaxCode2"
                                              label="TDS Tax Code 2"
                                              type="select"
                                              options={addNA(tdsTaxCodeOptions)}
                                              value={formData.tdsTaxCode2}
                                              onChange={(e: any) => {
                                                setFormData((prev: any) => ({
                                                  ...prev,
                                                  tdsTaxCode2: e,
                                                }));
                                              }}
                                              disabled={isDisabled}
                                              isBoxSelect
                                            />
                                          </Box>

                                          <Box flex={{ base: "1 1 100%", md: "1 1 45%" }}>
                                            <CustomInput
                                              name="tdsBasicAmount2"
                                              label="TDS Basic Amount 2"
                                              type="number"
                                              value={formData.tdsBasicAmount2}
                                              onChange={(e: any) => {
                                                setFormData((prev: any) => ({
                                                  ...prev,
                                                  tdsBasicAmount2: e.target.value,
                                                }));
                                              }}
                                              disabled={isDisabled}
                                              placeholder="Enter TDS basic amount 2"
                                              isBoxSelect
                                            />
                                          </Box>
                                        </HStack>
                                        </Flex>
                  )}

                  {/* ============================
                        GL ACCOUNT SECTION FIELDS
                  ============================ */}
                  {formData.tdsSectionType === "gl" && (
                    <TdsGlSection
                      formData={formData}
                      setFormData={setFormData}
                      companyCode={companyCode}
                      workflowProcess={workflowProcess}
                      isDisabled={isDisabled}
                    />
                  )}
                </Box>
              )}

              {/* ================================
                            EXCHANGE RATE TOGGLE
                            ================================== */}
              <FormControl display="flex" alignItems="center">
                <FormLabel
                  htmlFor="exchange-rate-applicable"
                  mb="0"
                  fontWeight="semibold"
                  fontSize="sm"
                  color="gray.700"
                >
                  Exchange Rate Applicable
                </FormLabel>
                <Switch
                  id="exchange-rate-applicable"
                  isChecked={formData.isExchangeRateApplicable}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setFormData((prev: any) => ({
                      ...prev,
                      isExchangeRateApplicable: isChecked,
                      exchangeRate: isChecked ? prev.exchangeRate : "",
                    }));
                  }}
                  disabled={isDisabled}
                  colorScheme="blue"
                  size="md"
                />
              </FormControl>

              {/* EXCHANGE RATE FIELD */}
              {formData.isExchangeRateApplicable && (
                <Box maxW="300px">
                  <CustomInput
                    name="exchangeRate"
                    label="Exchange Rate"
                    type="number"
                    value={formData.exchangeRate}
                    onChange={(e: any) => {
                      setFormData((prev: any) => ({
                        ...prev,
                        exchangeRate: e.target.value,
                      }));
                    }}
                    disabled={isDisabled}
                    placeholder="Enter exchange rate"
                    isBoxSelect
                  />
                </Box>
              )}
            </VStack>
          </Collapse>
        </Box>

        <Divider borderColor="gray.200" />

        {/* Approvals and Department Section */}
        <Box>
          <Flex justify="space-between" align="center">
            <Flex align="center" gap={3}>
              <Heading size="sm" color="gray.700">
                Approvals Selection
              </Heading>
              {['tillomed', 'marcan'].includes(workflowProcess?.processName) && <Button
                size="xs"
                colorScheme="teal"
                display={documentFlow === "Pending Approval" ? getFiUser(workflowProcess?.processName, accountDetails?.level) || accountDetails?.level === "level-1" ? undefined : 'none' : 'none'}
                variant="outline"
                leftIcon={<MdAssignmentInd />}
                onClick={() => setAssignDocument({ open: true, data: { _id: documentId, originalValues: { ...formData, Vendor_Name: dynamicSchemaData?.fields?.Vendor_Name?.editFieldValue || dynamicSchemaData?.fields?.Vendor_Name?.originalValue } } })}
              >
                Assign Document
              </Button>}
            </Flex>
            <IconButton
              aria-label="Toggle Approvals and Department"
              icon={isApprovalOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
              onClick={toggleApproval}
              size="sm"
              variant="ghost"
            />
          </Flex>
          <Collapse in={isApprovalOpen} animateOpacity>
            <HStack spacing={3} flexWrap="wrap" mt={2}>
              {workflowProcess?.processName === "domestic" && (
                <Box flex={{ base: "1 1 100%", md: "1" }} minW="180px">
                  <CustomInput
                    name="domesticInitiator"
                    label="Initiator"
                    type="select"
                    options={
                      documentFlow === "Pending Approval"
                        ? [
                          {
                            label: `${accountDetails?.username}`,
                            value: accountDetails?.userId,
                          },
                        ]
                        : fetchDomesticApprovers
                    }
                    value={formData.domesticInitiator || null}
                    onChange={(e: any) => {
                      setFormData((prev: any) => ({
                        ...prev,
                        domesticInitiator: e,
                      }));
                    }}
                    disabled={
                      approval?.length > 0 ? true : false
                    }
                    placeholder="Initiator"
                    isBoxSelect
                    isRequired={true}
                  />
                </Box>
              )}

              {workflowProcess?.processName === "zuventus" && (
                <Box flex={{ base: "1 1 100%", md: "1" }} minW="180px">
                  <CustomInput
                    name="zuventusInitiator"
                    label="Initiator"
                    type="select"
                    options={
                      documentFlow === "Pending Approval"
                        ? [
                          {
                            label: `${accountDetails?.username}`,
                            value: accountDetails?.userId,
                          },
                        ]
                        : fetchZuventusApprovers
                    }
                    value={formData.zuventusInitiator || null}
                    onChange={(e: any) => {
                      setFormData((prev: any) => ({
                        ...prev,
                        zuventusInitiator: e,
                      }));
                    }}
                    disabled={
                      approval?.length > 0 ? true : false
                    }
                    placeholder="Initiator"
                    isBoxSelect
                    isRequired={true}
                  />
                </Box>
              )}

              {workflowProcess?.processName == "marcan" && (
                <Box flex={{ base: "1 1 100%", md: "1" }} minW="180px">
                  <CustomInput
                    name="marcanApproval2"
                    label="Select Approver Flow"
                    type="select"
                    options={MarcanApproval2}
                    value={formData.marcanApproval2 || null}
                    onChange={(e: any) => {
                      setFormData((prev: any) => ({
                        ...prev,
                        marcanApproval2: e,
                      }));
                    }}
                    disabled={
                      approval?.length > 0 ? true : false
                    }
                    placeholder="Select Approver"
                    isBoxSelect
                    isRequired={true}
                  />
                  <Box
                    mt={3}
                    px={4}
                    py={3}
                    borderRadius="md"
                    border="1px solid"
                    borderColor="gray.200"
                    bg="gray.50"
                  >
                    <Checkbox
                      isChecked={!!formData.marcanUserFourFollowUp}
                      onChange={(e: any) =>
                        setFormData((prev: any) => ({
                          ...prev,
                          marcanUserFourFollowUp: e.target.checked,
                        }))
                      }
                      isDisabled={isDisabled || !formData.marcanApproval2}
                      colorScheme="blue"
                      fontWeight="semibold"
                    >
                      Enable Level-5 Follow-up
                    </Checkbox>
                  </Box>
                </Box>
              )}
              {workflowProcess?.processName === "emerging" && (
                <Flex gap={4} width="100%">
                  <CustomInput
                    name="department"
                    label="Department"
                    type="select"
                    options={departmentsOptions}
                    value={formData.department}
                    onChange={(e: any) => {
                      setFormData((prev: any) => ({
                        ...prev,
                        department: e,
                      }));
                    }}
                    disabled={
                      approval?.length > 0 ? true : false
                    }
                    isBoxSelect
                    isRequired={true}
                  />
                  <CustomInput
                    name="bukrs"
                    label="Bukrs"
                    type="select"
                    options={regionsOptions}
                    value={formData.bukrs}
                    onChange={(e: any) => {
                      setFormData((prev: any) => ({ ...prev, bukrs: e }));
                    }}
                    disabled={
                      approval?.length > 0 ? true : false
                    }
                    isBoxSelect
                    isRequired={true}
                  />
                </Flex>
              )}
              {workflowProcess?.processName === "tillomed" && (
                <Box flex={{ base: "1 1 100%", md: "1 1 45%" }} minW="180px">
                  <CustomInput
                    name="tillomedApproval"
                    label="Select Business And Department"
                    type="select"
                    options={tillomedList}
                    value={formData.tillomedApproval}
                    onChange={(e: any) => {
                      setFormData((prev: any) => ({
                        ...prev,
                        tillomedApproval: e,
                      }));
                    }}
                    disabled={
                      approval?.length > 0 ? true : false
                    }
                    isBoxSelect
                    isRequired={true}
                  />
                </Box>
              )}
            </HStack>
          </Collapse>
        </Box>

        <Divider borderColor="gray.200" />
        {workFlowData?.forwardDocument && (
          <Box>
            <CustomInput
              name="forwardDocument"
              label="Utility Bills"
              type="switch"
              value={formData.forwardDocument}
              onChange={(e: any) => {
                setFormData((prev: any) => ({ ...prev, forwardDocument: e.target.checked }));
              }}
              disabled={isDisabled}
              isBoxSelect
            />

            <Text fontSize="sm" color="gray.500" mt={1} ml={1}>
              Allows the document to skip steps and continue to the next stage
              of the flow.
            </Text>
          </Box>
        )}

        <Divider borderColor="gray.200" />

        {/* Line Items Section */}
        <Box>
          <Flex justify="space-between" align="center">
            <Heading size="sm" color="gray.700">
              Line Items
            </Heading>
            <IconButton
              aria-label="Toggle Line Items"
              icon={isLineItemsOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
              onClick={toggleLineItems}
              size="sm"
              variant="ghost"
            />
          </Flex>
          <Collapse in={isLineItemsOpen} animateOpacity>
            <Box mt={2}>
              {lineItems.length > 0 ? (
                <TableContainer
                  overflowY="auto"
                  overflowX="auto"
                  width="100%"
                  maxWidth={{ base: "100%", md: "50vw", lg: "50vw" }}
                >
                  <Table variant="simple" size="sm" minWidth="100%">
                    <Thead position="sticky" top={0} zIndex={1} bg="gray.100">
                      <Tr whiteSpace="nowrap">
                        <Th>Description</Th>
                        <Th>Plant Code</Th>
                        <Th>Business Place</Th>
                        <Th>Profit Center</Th>
                        <Th>Profit Center Desc</Th>
                        <Th>Cost Center</Th>
                        <Th>Cost Center Desc</Th>
                        <Th>Business Area</Th>
                        {workflowProcess?.processName === "emerging" && (
                          <Th>Debit/Credit</Th>
                        )}
                        {workflowProcess?.processName === "marcan" && (
                          <Th>Tax Jurisdiction</Th>
                        )}
                        <Th>Tax Code</Th>
                        <Th>GL Account</Th>
                        <Th>Internal Order</Th>
                        <Th>Remark</Th>
                        {/* <Th>Action</Th> */}
                      </Tr>
                    </Thead>
                    <Tbody>
                      {lineItems.map((item: any, index: number) => (
                        <Tr key={item.line_item_id || index} whiteSpace="nowrap">
                          <Td>
                            <Tooltip label={item.Item_Description} hasArrow>
                              <Box minW="150px" maxW="200px" isTruncated>
                                {item.Item_Description}
                              </Box>
                            </Tooltip>
                          </Td>
                          <Td>
                            <Box minW="280px">
                              <HStack>
                                <CustomInput
                                  name={`plantCode-${index}`}
                                  type="select"
                                  isBoxSelect
                                  options={plantCodeOptions || []}
                                  value={item.plantCode}
                                  // disabled={isDisabled}
                                  onChange={(selected: any) =>
                                    handlePlantCodeChange(index, selected)
                                  }
                                  style={{ minWidth: "150px" }}
                                />
                                <IconButton
                                  aria-label="Refresh"
                                  icon={<RepeatIcon />}
                                  size="sm"
                                  variant="ghost"
                                  colorScheme="blue"
                                  onClick={() => fetchPlantCodeOptions(true)}
                                  isDisabled={isDisabled}
                                />
                              </HStack>
                            </Box>
                          </Td>
                          <Td>
                            <Box minW="280px">
                              <HStack>
                                <CustomInput
                                  name={`businessPlace-${index}`}
                                  type="select"
                                  isBoxSelect
                                  options={['zuventus','domestic'].includes(workflowProcess?.processName) ? (item.businessPlaceOptions || []) : addNA(item.businessPlaceOptions) || []}
                                  value={item.businessPlace}
                                  // disabled={isDisabled}
                                  onChange={(selected: any) =>
                                    updateLineItem(index, "businessPlace", selected)
                                  }
                                  style={{ minWidth: "150px" }}
                                />
                                <IconButton
                                  aria-label="Refresh"
                                  icon={<RepeatIcon />}
                                  size="sm"
                                  variant="ghost"
                                  colorScheme="blue"
                                  onClick={() => {
                                    if (item.plantCode?.value) {
                                      fetchBusinessPlaceOptions(index, item.plantCode.value, true);
                                    } else {
                                      toast({ title: "Select Plant Code first", status: "warning" });
                                    }
                                  }}
                                  isDisabled={isDisabled || !item.plantCode}
                                />
                              </HStack>
                            </Box>
                          </Td>
                          <Td>
                            <Box minW="340px">
                              <HStack>
                                <CustomInput
                                  name={`profitCenter-${index}`}
                                  type="select"
                                  isBoxSelect
                                  options={addNA(profitCenterOptions)}
                                  value={item.profitCenter}
                                  disabled={isDisabled}
                                  onChange={(selected: any) =>
                                    handleProfitCenterChange(index, selected)
                                  }
                                  style={{ minWidth: "150px" }}
                                />
                                <IconButton
                                  aria-label="Refresh"
                                  icon={<RepeatIcon />}
                                  size="sm"
                                  variant="ghost"
                                  colorScheme="blue"
                                  onClick={() => fetchProfitCenterOptions(true)}
                                  isDisabled={isDisabled}
                                />
                              </HStack>
                            </Box>
                          </Td>
                          <Td>
                            <Box minW="220px">
                              <CustomInput
                                name={`profitCenterDesc-${index}`}
                                type="text"
                                value={
                                  item.profitCenter?.description ||
                                  item.profitCenter?.label ||
                                  ""
                                }
                                disabled
                              />
                            </Box>
                          </Td>
                          <Td>
                            <Box minW="340px">
                              <HStack>
                                <CustomInput
                                  name={`costCenter-${index}`}
                                  type="select"
                                  isBoxSelect
                                  options={addNA(item.costCenterOptions) || []}
                                  value={item.costCenter}
                                  disabled={(accountDetails?.level === "level-2" && workflowProcess?.processName === "domestic") ? true : isDisabled}
                                  onChange={(selected: any) =>
                                    handleCostCenterChange(index, selected)
                                  }
                                  style={{ minWidth: "150px" }}
                                />
                                <IconButton
                                  aria-label="Refresh"
                                  icon={<RepeatIcon />}
                                  size="sm"
                                  variant="ghost"
                                  colorScheme="blue"
                                  onClick={() => {
                                    if (item.profitCenter?.value) {
                                      fetchCostCenterOptions(index, item.profitCenter.value, true);
                                    } else {
                                      toast({ title: "Select Profit Center first", status: "warning" });
                                    }
                                  }}
                                  isDisabled={(accountDetails?.level === "level-2" && workflowProcess?.processName === "domestic") ? true : isDisabled || !item.profitCenter}
                                />
                              </HStack>
                            </Box>
                          </Td>
                          <Td>
                            <Box minW="240px">
                              <CustomInput
                                name={`costCenterDesc-${index}`}
                                type="text"
                                value={
                                  item.costCenter?.description ||
                                  item.costCenter?.label ||
                                  ""
                                }
                                disabled
                              />
                            </Box>
                          </Td>
                          <Td>
                            <Box minW="280px">
                              <HStack>
                                <CustomInput
                                  name={`businessArea-${index}`}
                                  type="select"
                                  isBoxSelect
                                  disabled={isDisabled}
                                  options={['zuventus','domestic'].includes(workflowProcess?.processName) ? (item.businessAreaOptions || []) : addNA(item.businessAreaOptions) || []}
                                  value={item.businessArea}
                                  onChange={(selected: any) =>
                                    updateLineItem(index, "businessArea", selected)
                                  }
                                  style={{ minWidth: "150px" }}
                                />
                                <IconButton
                                  aria-label="Refresh"
                                  icon={<RepeatIcon />}
                                  size="sm"
                                  variant="ghost"
                                  colorScheme="blue"
                                  onClick={() => {
                                    if (item.costCenter?.value && item.profitCenter?.value) {
                                      fetchBusinessAreaOptions(index, item.costCenter.value, item.profitCenter.value, true);
                                    } else {
                                      toast({ title: "Select Cost Center and Profit Center", status: "warning" });
                                    }
                                  }}
                                  isDisabled={isDisabled || !item.costCenter}
                                />
                              </HStack>
                            </Box>
                          </Td>
                          {workflowProcess?.processName === "emerging" && (
                            <Td>
                              <Box minW="150px">
                                <CustomInput
                                  name={`creditIndicator-${index}`}
                                  type="select"
                                  value={item.creditIndicator}
                                  isBoxSelect
                                  options={creditIndicator}
                                  onChange={(selected: any) =>
                                    updateLineItem(index, "creditIndicator", selected)
                                  }
                                  disabled={isDisabled}
                                />
                              </Box>
                            </Td>
                          )}
                          {workflowProcess?.processName === "marcan" && (
                            <Td>
                              <Box minW="150px">
                                <CustomInput
                                  name={`taxJurisdiction-${index}`}
                                  type="select"
                                  value={item.taxJurisdiction}
                                  options={addNA(taxJuridictionOptions)}
                                  onChange={(selected: any) =>
                                    updateLineItem(index, "taxJurisdiction", selected)
                                  }
                                  disabled={isDisabled}
                                  isBoxSelect
                                />
                              </Box>
                            </Td>
                          )}
                          <Td>
                            <Box minW="480px">
                              <HStack>
                                <CustomInput
                                  name={`taxCode-${index}`}
                                  type="select"
                                  isBoxSelect
                                  disabled={isDisabled}
                                  options={addNAObject(taxCodeOptions)}
                                  value={item.taxCode}
                                  onChange={(selected: any) =>
                                    updateLineItem(index, "taxCode", selected)
                                  }
                                  style={{ minWidth: "150px" }}
                                />
                                <IconButton
                                  aria-label="Refresh"
                                  icon={<RepeatIcon />}
                                  size="sm"
                                  variant="ghost"
                                  colorScheme="blue"
                                  onClick={() => fetchTaxCodeOptions(true)}
                                  isDisabled={isDisabled}
                                />
                              </HStack>
                            </Box>
                          </Td>
                          <Td>
                            <Box minW="340px">
                              <HStack>
                                <CustomInput
                                  name={`glAccount-${index}`}
                                  type="select"
                                  isBoxSelect
                                  disabled={isDisabled}
                                  options={['zuventus','domestic'].includes(workflowProcess?.processName) ? glAccountsOptions : addNA(glAccountsOptions)}
                                  value={item.glAccount}
                                  onChange={(selected: any) =>
                                    handleGlAccountChange(index, selected)
                                  }
                                  style={{ minWidth: "150px" }}
                                />
                                <IconButton
                                  aria-label="Refresh"
                                  icon={<RepeatIcon />}
                                  size="sm"
                                  variant="ghost"
                                  colorScheme="blue"
                                  onClick={() => fetchGlAccountsOptions(true)}
                                  isDisabled={isDisabled}
                                />
                              </HStack>
                            </Box>
                          </Td>
                          <Td>
                            <Box minW="320px">
                              <HStack>
                                <CustomInput
                                  name={`internalOrder-${index}`}
                                  type="select"
                                  isBoxSelect
                                  disabled={isDisabled}
                                  options={addNA(item.internalOrderOptions) || []}
                                  value={item.internalOrder}
                                  onChange={(selected: any) =>
                                    updateLineItem(index, "internalOrder", selected)
                                  }
                                  style={{ minWidth: "150px" }}
                                />
                                <IconButton
                                  aria-label="Refresh"
                                  icon={<RepeatIcon />}
                                  size="sm"
                                  variant="ghost"
                                  colorScheme="blue"
                                  onClick={() => {
                                    if (item.glAccount?.value) {
                                      fetchInternalOrderOptions(index, item.glAccount.value, item.profitCenter?.value || null, true);
                                    } else {
                                      toast({ title: "Select GL Account first", status: "warning" });
                                    }
                                  }}
                                  isDisabled={isDisabled || !item.glAccount}
                                />
                              </HStack>
                            </Box>
                          </Td>
                          <Td>
                            <Box minW="200px">
                              <CustomInput
                                name={`lineItemsRemark-${index}`}
                                placeholder="Add a Line Item Text.."
                                type="text"
                                value={item.remark}
                                disabled={isDisabled}
                                onChange={(e: any) =>
                                  updateLineItem(
                                    index,
                                    "remark",
                                    e.target.value
                                  )
                                }
                              />
                            </Box>
                          </Td>
                          {/* <Td>
                              <IconButton
                                aria-label="Delete line item"
                                icon={<Icon as={FaTrash} />}
                                colorScheme="red"
                                size="sm"
                                variant="ghost"
                                onClick={() => deleteLineItem(index)}
                                isDisabled={isDisabled}
                              />
                            </Td> */}
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </TableContainer>
              ) : (
                <Box
                  p={3}
                  textAlign="center"
                  color="gray.500"
                  bg="gray.100"
                  borderRadius="md"
                >
                  No line items available
                </Box>
              )}
            </Box>
          </Collapse>
        </Box>

        <Divider borderColor="gray.200" />

        {/* Remarks Section */}
        <Box>
          <Box mt={2}>
            <CustomInput
              name="remark"
              label="Header Texts"
              placeholder="Enter your remark here..."
              type="textarea"
              disabled={isDisabled}
              value={formData.remark}
              onChange={(e: any) =>
                setFormData((prev: any) => ({
                  ...prev,
                  remark: e.target.value,
                }))
              }
              isRequired={true}
            />
          </Box>
        </Box>
      </VStack>

      {assignDocument.open && <AssignDocumentModal
        isOpen={assignDocument.open}
        close={() => setAssignDocument({ open: false, data: null })}
        data={assignDocument.data}
        updateWorflow={(dt: any) => {
          setFormData((prev: any) => {
            const updated = { ...prev };
            const processName = workflowProcess?.processName;

            if (processName === "tillomed") {
              updated.tillomedApproval = dt;
            } else if (processName === "marcan") {
              updated.marcanApproval2 = dt;
            } else if (processName === "emerging") {
              updated.department = dt.department ? { label: dt.department, value: dt.department } : dt;
              updated.bukrs = dt.bukrs ? { label: dt.bukrs, value: dt.bukrs } : null;
            } else if (processName === "domestic") {
              updated.domesticInitiator = dt;
            } else if (processName === "zuventus") {
              updated.zuventusInitiator = dt;
            }
            return updated;
          });
        }}
      />}
    </Box>
  );
}
